import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import { useSelector, useDispatch } from 'react-redux'
import { cartItem } from '../features/cartdata';
import { Baseurl, key } from "../constants/env";

const Payment = (props) => {
  const {userid,totalprice,adress,phone,setRadio} = props
  const [amount, setAmount] = useState(""); // State to track user-entered amount
  const [paymentDetails, setPaymentDetails] = useState(null); // State to track payment response
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const{enqueueSnackbar} = useSnackbar();

  const handlePayment = async (event) => {
    setRadio('online')
    if(!adress || !phone ){
      alert('enter adress and phone number')
      return
    }
    function loadScript(src) {
      return new Promise((resolve) => {
          const script = document.createElement("script");
          script.src = src;
          script.onload = () => {
              resolve(true);
          };
          script.onerror = () => {
              resolve(false);
          };
          document.body.appendChild(script);
      });
  }

    if (!totalprice || isNaN(totalprice) || totalprice <= 0) {
      alert("Please enter a valid amount.");
      return;
    }

    const backendURL = `${Baseurl}`

    try {
      // Step 1: Create an order on the backend
      const currency = 'INR';
      const receiptId = '1234567890';

      const res = await loadScript(
        "https://checkout.razorpay.com/v1/checkout.js"
    );

    if (!res) {
        alert("Razorpay SDK failed to load. Are you online?");
        return;
    }

      const { data } = await axios.post(`${backendURL}/onlinePay`, {amount:totalprice,currency,receiptId});


      var option = {
        key:`${key}`,
        amount:data.amount,
        currency,
        name:"Kitchen-Ecart",
        description: "Kitchen-Ecart",
        image:"",
        order_id:data.id,
        handler: async function(response) {
          // console.log(response,'response');
          
          const body = {...response,}

          let validateResponse = await axios.post(`${Baseurl}/validate`,body)

          // console.log('validateResponse', validateResponse);
          if(validateResponse.status == 200){
            alert('Your payment is success')
            let data = {
              userid,
              totalprice,
              adress,
              mobile:phone,
              radio:'online',
              validateResponse:validateResponse?.data
            }
        axios.post(`${Baseurl}/placeorder`,data,{withCredentials:true}).then((resp)=>{
         if(resp.status === 200){
           dispatch(cartItem(0));
           localStorage.setItem('cart',0)
           enqueueSnackbar('Order Succesfully Placed',{variant:'success'})
          return navigate('/Profile/userorders',{replace:true})
         }
   
        }).catch((e)=>{
         console.log(e);
         enqueueSnackbar('Enter Required Fields ',{variant:'error'});
        })
          }
          

          if(validateResponse.status != 200 || !validateResponse?.status){
            alert('Your payment is failed try agiain later')
          }
          
        },
        prefill: {
          name: "Sam Joseph", 
          email: "samjoseph97.19@gmail.com",
          contact: "9000000000", 
        },
        notes: {
          address: "Razorpay Corporate Office",
        },
        theme: {
          color: "#3399cc",
        },
      }
      // const paymentObject = new window.Razorpay(option);
      // paymentObject.open();
      var rzp1 = new window.Razorpay(option);
      rzp1.on("payment.failed", function(response) {
        alert(response.error.code);
        alert(response.error.description);
        alert(response.error.source);
        alert(response.error.step);
        alert(response.error.reason);
        alert(response.error.metadata.order_id);
        alert(response.error.metadata.payment_id);
      })

      rzp1.open();
       event.preventDefault();

    
    } catch (error) {
      console.error("Payment Failed:", error);
      alert("Payment Failed. Please try again.");
    }
  };

  return (
    <div>
      <div>
        <button className='text-white' onClick={handlePayment}>Pay Online</button>
      </div>
    </div>
  );

}
export default Payment;